import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  const featured = testimonials.find(t => t.featured) ?? testimonials[0];
  const others = testimonials.filter(t => t !== featured);
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-213" data-mp="3b0krg8nc3ix3">
      <div className="mx-auto max-w-5xl" data-id="element-214" data-mp="3b0aws7rcgnl2">
        <div className="text-center" data-id="element-215" data-mp="36ypqx6d899kd">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-216" data-mp="36zqzn46rtjyx">
            Beliebt bei Lehrkräften
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-217" data-mp="2x0temb8k08ko">
            Was Mathematiklehrkräfte <span className="italic text-brand" data-id="element-218" data-mp="2s308tjb5xgkx">sagen.</span>
          </h2>
        </div>

        <figure className="relative mt-12 overflow-hidden rounded-3xl bg-ink px-7 py-10 text-cream sm:px-12 sm:py-14" data-id="element-219" data-mp="v8dnhrk7kmf1">
          <QuoteIcon className="h-10 w-10 text-brand" aria-hidden="true" data-id="element-220" data-mp="qav93lnf9ezn" />
          <Stars className="mt-5" data-id="element-221" data-mp="h4wvo4o4mgj9" />
          <blockquote className="mt-4 max-w-3xl font-display text-xl italic leading-relaxed sm:text-2xl" data-id="element-222" data-mp="h4n6uketiff5">
            „{featured.quote}“
          </blockquote>
          <figcaption className="mt-8 flex items-center gap-4" data-id="element-223" data-mp="78jzn053zqlc">
            <Avatar name={featured.name} tone="bg-brand text-white" data-id="element-224" data-mp="c6ve5o6cmp9w" />
            <span data-id="element-225" data-mp="c73pvcqqjoji">
              <span className="block text-sm font-bold" data-id="element-226" data-mp="c8ojn05873gb">{featured.name}</span>
              <span className="block text-xs text-cream/60" data-id="element-227" data-mp="zx7rjekd5e7v">
                {featured.role} · {featured.location}
              </span>
            </span>
          </figcaption>
        </figure>

        <div className="mt-5 grid gap-5 sm:grid-cols-2" data-id="element-228" data-mp="q6cudf5kwu7n">
          {others.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6 sm:p-7" data-id="element-229" data-mp="v44yr8neu8sq">
              <Stars data-id="element-230" data-mp="1itqshgl0jvtc" />
              <blockquote className="mt-4 flex-1 font-display text-base italic leading-relaxed text-ink/85" data-id="element-231" data-mp="1ith4tznfy0qt">
                „{item.quote}“
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-ink/10 pt-5" data-id="element-232" data-mp="1xhh4zsfud5k3">
                <Avatar name={item.name} tone="bg-white text-brand" data-id="element-233" data-mp="1sk7gcf0a0xxb" />
                <span data-id="element-234" data-mp="1ogsz5l0lqbia">
                  <span className="block text-sm font-bold text-ink" data-id="element-235" data-mp="1ofzqgei31bxi">{item.name}</span>
                  <span className="block text-xs text-ink/55" data-id="element-236" data-mp="1jh6dqoamdoye">
                    {item.role} · {item.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-237" data-mp="19r3nuwysor4a">
          Beispielhafte Testimonials zu Demonstrationszwecken.
        </p>
      </div>
    </section>;
}
function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-0.5 ${className}`} role="img" aria-label="5 von 5 Sternen" data-id="element-238" data-mp="vsdmv68uu7an">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-239" data-mp="qu2gj5hrqex6" data-mpi={i} />)}
    </div>;
}
function Avatar({
  name,
  tone
}: {
  name: string;
  tone: string;
}) {
  return <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-display text-base font-black ${tone}`} aria-hidden="true" data-id="element-240" data-mp="37efjjiiriv5y">
      {name.charAt(0)}
    </span>;
}